import { appRoutes, templateRoutes, eventRoutes, dashboardRoutes } from '@/data/routes';
import type { AppRole } from '@/types/domain';

export interface NavigationItem {
  label: string;
  href: string;
  roles?: AppRole[];
}

export const navigationItems: NavigationItem[] = [
  { label: 'Current Masses', href: appRoutes.masses },
  { label: 'My Signups', href: appRoutes.mySignups },
  { label: 'Player Stats', href: appRoutes.playerStats },
  { label: 'Profile', href: appRoutes.profile },
  { label: 'Create Mass', href: eventRoutes.create, roles: ['owner', 'admin', 'officer', 'mass_manager'] },
  { label: 'Mass Templates', href: templateRoutes.list, roles: ['owner', 'admin', 'officer'] },
  { label: 'Dashboard', href: dashboardRoutes.home, roles: ['owner', 'admin', 'officer', 'mass_manager'] },
];
